import { render, staticRenderFns } from "./SlideElement.vue?vue&type=template&id=ba362e80&scoped=true&"
import script from "./SlideElement.vue?vue&type=script&lang=ts&"
export * from "./SlideElement.vue?vue&type=script&lang=ts&"
import style0 from "./SlideElement.vue?vue&type=style&index=0&id=ba362e80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba362e80",
  null
  
)

export default component.exports